import { ClipboardModule } from '@angular/cdk/clipboard';
import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { OpaHeaderComponent } from '@app/shared/ui';
import { Highlight } from 'ngx-highlightjs';
import { HighlightLineNumbers } from 'ngx-highlightjs/line-numbers';

@Component({
  selector: 'app-host-this-tool',
  imports: [
    ClipboardModule,
    Highlight,
    HighlightLineNumbers,
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
    OpaHeaderComponent,
  ],
  templateUrl: './host-this-tool.component.html',
  styleUrls: ['./host-this-tool.component.scss'],
})
export class HostThisToolComponent {
  private _snackBar = inject(MatSnackBar);

  openSnackBar(message: string) {
    this._snackBar.open(message, '', { duration: 3000 });
  }

  public widgetCode = `<iframe
  scrolling="no"
  frameborder="0"
  width="200"
  height="260"
  src="https://reproductivehealthservices.gov/locator-widget/partner-sidebar-1">
</iframe>`;
}
